/**
 * MONDE STORE - Predictive Search Controller
 */

class PredictiveSearchManager {
  constructor() {
    this.modal = document.querySelector('#SearchModal');
    this.triggers = document.querySelectorAll('[data-search-trigger]');
    this.closeBtn = document.querySelector('#SearchModalClose');
    this.input = document.querySelector('#SearchInput');
    this.resultsContainer = document.querySelector('#SearchResults');
    this.debounceTimer = null;

    this.init();
  }

  init() {
    this.triggers.forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        this.open();
      });
    });

    if (this.closeBtn) {
      this.closeBtn.addEventListener('click', () => this.close());
    }

    if (this.input) {
      this.input.addEventListener('input', () => {
        clearTimeout(this.debounceTimer);
        this.debounceTimer = setTimeout(() => this.performSearch(), 300);
      });
    }

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.modal && this.modal.classList.contains('is-active')) {
        this.close();
      }
    });
  }

  open() {
    if (this.modal) {
      this.modal.classList.add('is-active');
      document.body.style.overflow = 'hidden';
      if (this.input) {
        setTimeout(() => this.input.focus(), 150);
      }
    }
  }

  close() {
    if (this.modal) {
      this.modal.classList.remove('is-active');
      document.body.style.overflow = '';
    }
  }

  async performSearch() {
    const query = this.input.value.trim();
    if (!query || query.length < 2) {
      if (this.resultsContainer) this.resultsContainer.innerHTML = '';
      return;
    }

    try {
      const res = await fetch(`/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product,collection&resources[limit]=6`);
      if (res.ok) {
        const data = await res.json();
        this.renderResults(data.resources.results);
      }
    } catch (e) {
      console.error(e);
    }
  }

  renderResults(results) {
    if (!this.resultsContainer) return;

    const products = results.products || [];
    const collections = results.collections || [];

    if (products.length === 0 && collections.length === 0) {
      this.resultsContainer.innerHTML = `
        <div style="padding: 2rem 0; color: var(--color-text-muted);">
          "${this.input.value}" aramasıyla eşleşen ürün bulunamadı.
        </div>
      `;
      return;
    }

    let html = '';

    if (collections.length > 0) {
      html += `
        <div style="margin-bottom: 2rem;">
          <div class="eyebrow" style="margin-bottom: 0.5rem;">Koleksiyonlar</div>
          <div style="display: flex; gap: 0.75rem; flex-wrap: wrap;">
            ${collections.map(c => `
              <a href="${c.url}" class="search-pill">${c.title}</a>
            `).join('')}
          </div>
        </div>
      `;
    }

    if (products.length > 0) {
      html += `
        <div>
          <div class="eyebrow" style="margin-bottom: 1rem;">Ürünler</div>
          <div class="product-grid" style="grid-template-columns: repeat(auto-fill, minmax(180px, 1fr)); gap: 1.5rem;">
            ${products.map(p => `
              <a href="${p.url}" style="display: block; text-decoration: none;">
                <div style="aspect-ratio: 4/5; background: var(--color-background-secondary); overflow: hidden; margin-bottom: 0.5rem;">
                  <img src="${p.image}" alt="${p.title}" style="width:100%; height:100%; object-fit: cover;">
                </div>
                <div style="font-family: var(--font-heading); font-size: 1.1rem; color: var(--color-primary);">${p.title}</div>
                <div style="font-size: 0.875rem; font-weight: 500; color: var(--color-primary);">${p.price} TL</div>
              </a>
            `).join('')}
          </div>
        </div>
      `;
    }

    this.resultsContainer.innerHTML = html;
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new PredictiveSearchManager();
});
